export default __webpack_public_path__ + "media/zurb/img/legacy/clue/clue-large-3cc79097695617e17ff80c861e470042.png";